module.exports = __webpack_public_path__ + "static/media/website-logo.703a8913.png";